module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - chunjiman.1dedc9ea.pdf";